/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const CrossModalCloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      data-palette="CrossModalCloseIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-331 -504) translate(0 489) translate(0 2) translate(331 13)"
                />
                <path
                  fill="#A6A9AD"
                  fillRule="nonzero"
                  d="M12 10.586L16.95 5.636 18.364 7.05 13.414 12 18.364 16.95 16.95 18.364 12 13.414 7.05 18.364 5.636 16.95 10.586 12 5.636 7.05 7.05 5.636z"
                  transform="translate(-331 -504) translate(0 489) translate(0 2) translate(331 13)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default CrossModalCloseIcon;
